var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUpload = function SvgIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M24.033 12.388h-8.034v10.384a2 2 0 0 1-4 0V12.388H3.966c-.883 0-1.332-1.06-.72-1.694L13.282.305a1 1 0 0 1 1.438 0l10.033 10.389c.613.634.163 1.694-.72 1.694M2 27.87a2 2 0 0 0-2 2V30a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-.13a2 2 0 0 0-2-2z"
  })));
};
export default SvgIconUpload;